module.exports = __webpack_public_path__ + "img/blacknovember.9557eb35.webp";